import {
    createContext,
    useContext,
    useEffect,
    useState,
} from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from '@/firebaseConfig.js'


const AuthContext = createContext({
    user: null,
    loading: true,
    logout: async () => {},
    refreshUser: async () => {},
});

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    // Bumped after auth.currentUser.reload() so consumers re-render and read
    // the freshly-mutated emailVerified/etc. fields off the same user object.
    const [, forceRerender] = useState(0);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
            setUser(firebaseUser);
            setLoading(false);
        });
        return () => unsubscribe();
    }, []);

    const logout = async () => {
        await signOut(auth);
    };

    // Firebase only updates emailVerified on the cached user object after the
    // user re-authenticates or we explicitly reload it. Call this after the
    // user clicks the verification link (or on an interval) to pick it up.
    const refreshUser = async () => {
        if (!auth.currentUser) return;
        await auth.currentUser.reload();
        forceRerender((tick) => tick + 1);
    };

    return (
        <AuthContext.Provider value={{ user, loading, logout, refreshUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
